<template>
  <div>
    <case-search-form></case-search-form>
    <case-table></case-table>
  </div>
</template>

<script>
import CaseSearchForm from "./case-search-form";
import CaseTable from "./case-table";
export default {
  components: {
    CaseSearchForm,
    CaseTable
  }

}
</script>
<style scoped>

</style>